import React from 'react';
import axios from 'axios';
import {Line} from 'react-chartjs-2';

class HistoryRow extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: props.loading !== undefined ? props.loading : true,
      error: props.error !== undefined ? props.error : false,
      message: props.message !== undefined ? props.message : null,
      url: props.url,
      data: undefined
    };
  }

  componentDidMount() {
    const data_location = this.props.code; 
    const data_param = this.props.param;
    const url = process.env.REACT_APP_API_URL + '/waves/' + data_location + '/' + data_param + '/history';
    axios.get(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      crossdomain: true,
    })
    .then(res => {
      // console.log("using data: " + res.data);
      this.setState({ loading: false, data: res.data });
    })
    .catch(error => {
      console.log("error loading data: " + error);
      this.setState({ loading: false, error: true, message: error.message });
    });
  }

  render(data) {
    if (this.state.loading) {
      return <div>Loading</div>;
    } else if (this.state.error) {
      return <div className="error">ERROR: {this.state.message}</div>;
    } else {
      let labels = [];
      let dataset = { label: this.props.title, data: [] };
      for (var row of this.state.data) {
        // calculate data age for the label
        let dt = new Date(row.dateTime);
        let age = Math.round((new Date().getTime() - dt.getTime()) / 1000 / 3600);
        labels.unshift("-" + age + "h");
        // Add data value
        dataset.data.unshift(row[this.props.param]);
      }
      let chartData = {
        labels: labels,
        datasets: [dataset],
      };
      let chartOptions = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
      };
      return (
        <div>
          <Line data={chartData} options={chartOptions} height={1} width={6} />
        </div>);
    }
  }

}

export default HistoryRow;



// WEBPACK FOOTER //
// ./src/Components/HistoryRow.jsx